import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";

import { ApiService } from "./utilities/api.service";
import { Invite, InviteListConfig } from "../../models";
import { InviteListResult } from "../../interfaces";

@Injectable()
export class InviteService {
  constructor(private apiService: ApiService) {}

  public checkOne(invite: Invite): Observable<Invite> {
    var recipient = invite.recipient;
    var community = invite.community;
    var targetModel = invite.targetModel;
    var targetDiscussion = null;

    if (targetModel === "Discussion") {
      targetDiscussion = invite.target;
    }

    // GET /api/invites/check/to/:recipient/community/:community/discussion/:targetDiscussion/targetModel/:targetModel
    const getURL = `/invites/check/to/${recipient}/community/${community}/discussion/${targetDiscussion}/targetModel/${targetModel}`;
    return this.apiService.get(getURL).pipe(map((data) => data.invite));
  }

  public saveOne(invite: Invite): Observable<Invite> {
    var sender = invite.sender;
    var recipient = invite.recipient;
    var community = invite.community;
    var targetModel = invite.targetModel;
    var targetDiscussion = null;

    if (targetModel === "Discussion") {
      targetDiscussion = invite.target;
    }

    // POST /api/invites/send/from/:sender/to/:recipient/community/:community/discussion/:targetDiscussion/targetModel/:targetModel
    const postURL = `/invites/send/from/${sender}/to/${recipient}/community/${community}/discussion/${targetDiscussion}/targetModel/${targetModel}`;
    return this.apiService.post(postURL).pipe(map((data) => data.invite));
  }

  public accept(invite: any) {
    var community;
    var inviteId = invite.id;
    var targetModel = invite.targetModel;
    var targetDiscussion = null;

    if (targetModel === "Discussion") {
      targetDiscussion = invite.target.slug;
      community = invite.target.community.name;
    }

    if (targetModel === "Community") {
      community = invite.target.name;
    }

    // PUT /api/invites/:invite/accept/community/:community/discussion/:targetDiscussion/targetModel/:targetModel
    const putURL = `/invites/${inviteId}/accept/community/${community}/discussion/${targetDiscussion}/targetModel/${targetModel}`;
    return this.apiService.put(putURL);
  }

  public reject(invite: any) {
    var community;
    var inviteId = invite.id;
    var targetModel = invite.targetModel;
    var targetDiscussion = null;

    if (targetModel === "Discussion") {
      targetDiscussion = invite.target.slug;
      community = invite.target.community.name;
    }

    if (targetModel === "Community") {
      community = invite.target.name;
    }

    // PUT /api/invites/:invite/reject/community/:community/discussion/:targetDiscussion/targetModel/:targetModel
    const putURL = `/invites/${inviteId}/reject/community/${community}/discussion/${targetDiscussion}/targetModel/${targetModel}`;
    return this.apiService.put(putURL);
  }

  public findMany(
    username: string,
    config: InviteListConfig
  ): Observable<InviteListResult> {
    let params = {};

    Object.keys(config).forEach((key) => {
      params[key] = config[key];
    });

    // GET /api/profiles/:username/invites?limit=9&offset=0&type=sent
    const getURL = `/profiles/${username}/invites`;
    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
